import {Component, input, OnInit} from '@angular/core';
import {FormsModule} from "@angular/forms";
import {TranslateModule} from "@ngx-translate/core";
import {
  PlanningRegionProgAnnonceModalComponent
} from "../../../../shared/modals/planning-region/planning-region-prog-annonce-modal/planning-region-prog-annonce-modal.component";
import {
  PlanningRegionGestionCirculationModalComponent
} from "../../../../shared/modals/planning-region/planning-region-gestion-circulation-modal/planning-region-gestion-circulation-modal.component";
import {
  PlanningRegionExportsModalComponent
} from "../../../../shared/modals/planning-region/planning-region-exports-modal/planning-region-exports-modal.component";
import {
  PlanningRegionLegendModalComponent
} from "../../../../shared/modals/planning-region/planning-region-legend-modal/planning-region-legend-modal.component";
import {PlanningRegionApiService} from "../../../../services/api/planning-region-api.service";
import {BaseComponent} from "../../../../shared/base/base.component";
import {RegionGroup, PlanningRegion} from "../../../../models/planning_region.model";
import {NgbModal} from "@ng-bootstrap/ng-bootstrap";

@Component({
  selector: 'app-planning-region-actions',
  standalone: true,
    imports: [
        FormsModule,
        TranslateModule
    ],
  templateUrl: './planning-region-actions.component.html',
  styleUrl: './planning-region-actions.component.scss'
})
export class PlanningRegionActionsComponent extends BaseComponent implements OnInit {
  data = input.required<PlanningRegion>()
  regions = input.required<RegionGroup[]>()

  constructor(
    private planningRegionApiService: PlanningRegionApiService,
    private modalService: NgbModal
  ) {
    super();
  }

  ngOnInit() {
    this.planningRegionApiService.reloadPlanningRegion$.subscribe((regionId) => {
      if (regionId) { this.idRegion = regionId; }
    });
  }

  changeRegion(event: Event): void {
    const inputElement = event.target as HTMLSelectElement;
    const url = inputElement.value;
    const regionId = parseInt(url.split('/').slice(-2, -1)[0], 10);
    this.planningRegionApiService.reloadPlanningRegion(regionId);
    window.location.href = url;
    this.idRegion = regionId;
  }

  public openProgAnnonceModal(): void {
    if (this.data().cinemas && this.data().cinemas.length > 0) {
      const modalRef = this.modalService.open(PlanningRegionProgAnnonceModalComponent,
        {
          size: 'lg',
          centered: true,
        }
      );
      modalRef.componentInstance.cinemas = this.data().cinemas;
      modalRef.componentInstance.title = 'progAnnonceModal.modalHeader.title';
    }
  }

  public openGestionCirculationModal(): void {
    const modalRef = this.modalService.open(PlanningRegionGestionCirculationModalComponent,
      {
        windowClass: 'modal-xxl',
        centered: true,
      });
    modalRef.componentInstance.title = 'circulationModal.modalHeader.title';
  }

  public openExportsModal(): void {
    if (this.data().cinemas && this.data().cinemas.length > 0) {
      const modalRef = this.modalService.open(PlanningRegionExportsModalComponent,
        {
          size: 'lg',
          centered: true,
        });
      modalRef.componentInstance.cinemas = this.data().cinemas;
      modalRef.componentInstance.title = 'exports.modalHeader.title';
    }
  }

  public openLegendModal(): void {
    const modalRef = this.modalService.open(PlanningRegionLegendModalComponent,
      {
        size: 'lg',
        centered: true,
      }
    );
    modalRef.componentInstance.title = 'legend.modalHeader.title';
  }
}
